export var bindMethod = function (add) { return add ? 'addEventListener' : 'removeEventListener'; };
export var bindEmitterMethod = function (add) { return add ? 'on' : 'off'; };
